/**
 * Cross-module X XWP-74 (XO-14, XD-224; CP §11 last paragraph, §15.20 bullets 1-2) — the explicit
 * « ouvrir dans une nouvelle fenêtre » flow: from a form holding work in progress (S1, the caisse,
 * the avoir and BC editors…), a supporting page opens in a NEW window after a question that says the
 * form stays open; the opened window offers « Retourner vers la fenêtre précédente ».
 *
 * Only this flow keeps the window opener (XD-224, amends refonte A-35 for it alone): the source
 * window carries a stable name (PREFIXE_NOM + jeton) and the opened window receives `?source=<jeton>`.
 * The jeton only ever names a window of this session — the return action focuses that window, it
 * never navigates to a URL read from the query string.
 */
import { STOCK_ROUTE } from "./stock-views.config.js";

export const FENETRE_SOURCE = Object.freeze({
  /** Query parameter carried by the opened window's first URL. */
  PARAM: "source",
  /** `window.name` of a source window: PREFIXE_NOM + its jeton. */
  PREFIXE_NOM: "pharmakon-fenetre-",
  /** Length of a jeton (lowercase base-36). */
  JETON_LONGUEUR: 16,
  /** sessionStorage key (per tab) of the opened window's source jeton — survives reloads and in-tab navigation. */
  CLE_SESSION: "pharmakon.fenetre-source",
  /** Target of `window.open`: always a new tab / window, never a named one (two openings never share it). */
  CIBLE: "_blank",
});

/**
 * The supporting pages of CP §15.20 (« Stock & Lots or another supporting page »): the pages a user
 * consults during a filling. A link from a form with unsaved work to one of them asks whether to open
 * it in a new window instead of leaving the form. Matched on the pathname (react-router patterns),
 * most specific first; `libelle` completes « Ouvrir … dans une nouvelle fenêtre ? ».
 */
export const PAGES_SUPPORT = Object.freeze([
  Object.freeze({ cle: "STOCK_LOTS", motif: STOCK_ROUTE, libelle: "Stock & lots" }),
  Object.freeze({ cle: "FICHE_PRODUIT", motif: "/produits/:id", libelle: "la fiche produit" }),
  Object.freeze({ cle: "PRODUITS", motif: "/produits", libelle: "la liste des produits" }),
  Object.freeze({ cle: "RECHERCHE_PRODUITS", motif: "/recherche-produits", libelle: "la recherche produit" }),
  Object.freeze({ cle: "FICHE_FOURNISSEUR", motif: "/fournisseurs/:id", libelle: "la fiche du fournisseur" }),
  Object.freeze({ cle: "FOURNISSEURS", motif: "/fournisseurs", libelle: "la liste des fournisseurs" }),
  Object.freeze({ cle: "FICHE_CLIENT", motif: "/clients/:id", libelle: "la fiche du client" }),
  Object.freeze({ cle: "CLIENTS", motif: "/clients", libelle: "la liste des clients" }),
]);

/**
 * Creation routes that share a supporting pattern but are steps of the form itself (the S1 bridge
 * « Nouveau fournisseur », the product creation…): they keep their same-window round trip.
 */
export const PAGES_SUPPORT_EXCLUES = Object.freeze(["/produits/nouveau", "/fournisseurs/nouveau", "/clients/nouveau"]);

export default FENETRE_SOURCE;
